import { Input, EventEmitter, Output, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';

export interface NavigationData {
  direction?: string;
}

@Component({
  template: '',
})
export class MenuBase {
  navigationSubscription: Subscription = new Subscription();
  navigator = new Subject();
  @Input() navigatorObs: Observable<any> = new Subject();
  @Output() onNavigate = new EventEmitter();
  index = 0;
  navigated = false;
  allTabs = [];
  navigationData: NavigationData = {};

  constructor() {
    this.handleNavigate = this.handleNavigate.bind(this);
    this.handleNavigated = this.handleNavigated.bind(this);
  }
  onLeave(): any {
    return true;
  }
  handleChange(e: any) {
    this.navigated = true;
  }

  openNext() {
    this.navigated = false;
    const tabLength = this.allTabs.length;

    if (tabLength - 1 > this.index) {
      const index = this.index + 1;
      this.handleChange({ index });
    } else {
      this.onNavigate.emit({
        ...this.navigationData,
        navigated: false,
        persisted: true,
      });
    }
  }

  openPrev() {
    this.navigated = false;
    if (this.index > 0) {
      this.handleChange({ index: this.index - 1 });
    } else {
      this.onNavigate.emit({
        ...this.navigationData,
        navigated: false,
        persisted: true,
      });
    }
  }

  handleNavigate(navigationData: NavigationData) {
    this.navigationData = navigationData;
    if (this.allTabs.length) {
      this.triggerNavigate(navigationData);
    } else {
      const persisted = this.onLeave();
      const returnType = typeof persisted;

      if (
        returnType === 'object' &&
        persisted.constructor &&
        persisted.constructor.name === 'ZoneAwarePromise'
      ) {
        persisted.then((persisted: any) => {
          this.onNavigate.emit({
            ...navigationData,
            navigated: this.navigated,
            persisted,
          });
        });
      } else {
        this.onNavigate.emit({
          ...navigationData,
          navigated: this.navigated,
          persisted,
        });
      }
    }
  }

  configureNavigation() {
    this.navigationSubscription = this.navigatorObs.subscribe(
      this.handleNavigate
    );
  }
  ngOnDestroy() {
    this.navigationSubscription?.unsubscribe();
  }

  handleNavigated({ navigated, direction, persisted }: any) {
    if (navigated === false && persisted) {
      switch (direction) {
        case 'NEXT':
          this.openNext();
          break;
        case 'PREV':
          this.openPrev();
      }
      return;
    }

    this.onNavigate.emit({
      direction,
      navigated: false,
      persisted,
    });
  }
  triggerNavigate(direction: any) {
    this.navigator.next(direction);
  }

  triggerValidations(form: FormGroup) {
    form.markAllAsTouched();
    form.markAsDirty();
  }
}
